var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { alpha, Box, Button, Chip, FormHelperText, Grid, IconButton, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { CloudUploadIcon, Unlink05Icon } from 'hugeicons-react';
import * as pdfJs from 'pdfjs-dist';
import { Fragment, useEffect, useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import { X } from 'react-feather';
import { FileErrorType } from '../../../application/common/enums/file-error-type';
import useTranslate from '../../../localization/helpers';
import FileIconDuoTone from '../../icons/components/file-icon';
import FolderIconDuoTone from '../../icons/components/folder-icon';
pdfJs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@".concat(pdfJs.version, "/build/pdf.worker.min.mjs");
export var MultipleLinkedFileUpload = function (_a) {
    var onChange = _a.onChange, onValidationError = _a.onValidationError, handleDelink = _a.handleDelink, allowedFileSize = _a.allowedFileSize, allowedTotalFileSize = _a.allowedTotalFileSize, allowedFileTypes = _a.allowedFileTypes, allowedFileTypesText = _a.allowedFileTypesText, uploadLabel = _a.uploadLabel, error = _a.error, infoText = _a.infoText, _b = _a.initialFiles, initialFiles = _b === void 0 ? [] : _b, _c = _a.fileDetails, fileDetails = _c === void 0 ? [] : _c, _d = _a.isFolderUpload, isFolderUpload = _d === void 0 ? false : _d, _e = _a.isFileUpload, isFileUpload = _e === void 0 ? false : _e, _f = _a.isFolderUploadDialogOpen, isFolderUploadDialogOpen = _f === void 0 ? false : _f, _g = _a.existingModelCount, existingModelCount = _g === void 0 ? 0 : _g, enableFolderUpload = _a.enableFolderUpload, onFolderUpload = _a.onFolderUpload;
    var theme = useTheme();
    var _h = useTranslate(), translate = _h.translate, tWithField = _h.tWithField;
    var isXs = useMediaQuery(theme.breakpoints.down('sm'));
    var _j = __read(useState([]), 2), uploadedFiles = _j[0], setUploadedFiles = _j[1];
    var _k = __read(useState(''), 2), errorText = _k[0], setErrorText = _k[1];
    var _l = __read(useState(true), 2), canUpload = _l[0], setCanUpload = _l[1];
    var _m = __read(useState(FileErrorType.NoError), 2), currentErrorType = _m[0], setCurrentErrorType = _m[1];
    useEffect(function () {
        if (initialFiles && initialFiles.length > 0) {
            // Merge form files with uploadedFiles, preserving File objects
            setUploadedFiles(function (prevFiles) {
                // Check if files actually changed to prevent unnecessary updates
                var hasChanged = initialFiles.length !== prevFiles.length ||
                    initialFiles.some(function (formFile, idx) { var _a; return formFile.fileName !== ((_a = prevFiles[idx]) === null || _a === void 0 ? void 0 : _a.fileName); });
                if (!hasChanged)
                    return prevFiles;
                var mergedFiles = initialFiles.map(function (formFile) {
                    // Find existing file in uploadedFiles to preserve File object
                    var existingFile = prevFiles.find(function (f) { var _a, _b; return ((_a = f.uploadedFile) === null || _a === void 0 ? void 0 : _a.name) === ((_b = formFile.uploadedFile) === null || _b === void 0 ? void 0 : _b.name); });
                    return __assign(__assign({}, formFile), { uploadedFile: existingFile ? existingFile.uploadedFile : formFile.uploadedFile });
                });
                return mergedFiles;
            });
        }
        else {
            // If initialFiles is empty, keep existing uploadedFiles unless explicitly cleared
            setUploadedFiles(function (prevFiles) { return (prevFiles.length > 0 ? prevFiles : []); });
        }
    }, [initialFiles]);
    useEffect(function () {
        if (error)
            setErrorText(error);
    }, [error]);
    useEffect(function () {
        if (uploadedFiles.length > 0) {
            var uploadedFileList = uploadedFiles
                .map(function (x) { return x.uploadedFile; })
                .filter(function (f) { return !!f; });
            if (uploadedFileList.some(checkFileSize)) {
                fileSizeError();
            }
            else if (checkTotalFileSize(uploadedFileList)) {
                totalFileSizeError();
            }
            else {
                // Only clear size-related errors, not corruption or type errors
                if (currentErrorType === FileErrorType.SizeError ||
                    currentErrorType === FileErrorType.TotalSizeError ||
                    currentErrorType === FileErrorType.NoError) {
                    if (!error && errorText !== '') {
                        setErrorText('');
                    }
                    if (errorText !== '') {
                        onValidationError(false, FileErrorType.NoError);
                        setCurrentErrorType(FileErrorType.NoError);
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uploadedFiles]);
    var isFileAlreadyUploaded = function (file) {
        return uploadedFiles.some(function (f) { return f.fileName === file.name; });
    };
    var checkFileSize = function (file) {
        return allowedFileSize && file.size / 1024 / 1024 > allowedFileSize;
    };
    var checkTotalFileSize = function (files) {
        var totalSize = files.reduce(function (acc, file) { return acc + file.size; }, 0);
        return allowedTotalFileSize && totalSize / 1024 / 1024 > allowedTotalFileSize;
    };
    var duplicateFileError = function (fileName) {
        setErrorText(tWithField('fileUpload.duplicateFileError', fileName));
        onValidationError(true, FileErrorType.DuplicateError);
        setCurrentErrorType(FileErrorType.DuplicateError);
        setCanUpload(true);
    };
    var fileTypeError = function () {
        setErrorText(translate('fileUpload.fileTypeError', {
            field: allowedFileTypesText
        }));
        onValidationError(true, FileErrorType.TypeError);
        setCurrentErrorType(FileErrorType.TypeError);
        setCanUpload(true);
    };
    var fileSizeError = function () {
        setErrorText(translate('fileUpload.fileSizeError', {
            count: allowedFileSize
        }));
        onValidationError(true, FileErrorType.SizeError);
        setCurrentErrorType(FileErrorType.SizeError);
        setCanUpload(true);
    };
    var totalFileSizeError = function () {
        setErrorText(translate('fileUpload.totalFileSizeError', {
            count: allowedTotalFileSize
        }));
        onValidationError(true, FileErrorType.TotalSizeError);
        setCurrentErrorType(FileErrorType.TotalSizeError);
        setCanUpload(true);
    };
    var corruptedFileError = function (fileName) {
        setErrorText(tWithField('fileUpload.corruptedFileError', fileName));
        onValidationError(true, FileErrorType.CorruptedError);
        setCanUpload(true);
    };
    var validatePDF = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var arrayBuffer, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, file.arrayBuffer()];
                case 1:
                    arrayBuffer = _b.sent();
                    return [4 /*yield*/, pdfJs.getDocument({ data: arrayBuffer }).promise];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleFileChange = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var filesArray, filesByFolder, folderPaths_1, parentFolderName_1, filesArray_1, filesArray_1_1, file, rel, pathParts, childFolderName, folderStructure, folderNames, duplicateFiles, validFiles, corruptedFileNames, _loop_1, filesArray_2, filesArray_2_1, file, e_1_1, errorMessage, updatedFiles;
        var e_2, _a, e_1, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    filesArray = [];
                    if (files instanceof FileList) {
                        filesArray = Array.from(files);
                    }
                    else if (Array.isArray(files)) {
                        filesArray = files;
                    }
                    else {
                        filesArray = [files];
                    }
                    if (!enableFolderUpload) return [3 /*break*/, 1];
                    // Validation: Check if folder is empty (no files selected)
                    if (!filesArray || filesArray.length === 0) {
                        setErrorText(translate('fileUpload.emptyFolderError'));
                        onValidationError(true, FileErrorType.TypeError);
                        setCurrentErrorType(FileErrorType.TypeError);
                        return [2 /*return*/];
                    }
                    filesByFolder = new Map();
                    folderPaths_1 = new Map();
                    parentFolderName_1 = '';
                    try {
                        for (filesArray_1 = __values(filesArray), filesArray_1_1 = filesArray_1.next(); !filesArray_1_1.done; filesArray_1_1 = filesArray_1.next()) {
                            file = filesArray_1_1.value;
                            rel = file.webkitRelativePath;
                            if (rel === null || rel === void 0 ? void 0 : rel.trim()) {
                                pathParts = rel === null || rel === void 0 ? void 0 : rel.split('/').filter(function (part) { return part.trim() !== ''; });
                                // Extract parent folder name (first level - Asset Name)
                                if (!parentFolderName_1 && pathParts[0]) {
                                    parentFolderName_1 = pathParts[0].trim();
                                }
                                // Only process files at exactly 3 levels: AssetName/ModelNumber/File.pdf
                                // Silently ignore files at other levels or in subfolders
                                if (pathParts.length !== 3) {
                                    continue;
                                }
                                // Only process PDF files, silently ignore non-PDF files
                                if (!file.name.toLowerCase().endsWith('.pdf')) {
                                    continue;
                                }
                                childFolderName = pathParts[1].trim();
                                if (childFolderName) {
                                    if (!filesByFolder.has(childFolderName)) {
                                        filesByFolder.set(childFolderName, []);
                                        folderPaths_1.set(childFolderName, "".concat(pathParts[0], "/").concat(childFolderName));
                                    }
                                    // Store file info with File object
                                    filesByFolder.get(childFolderName).push({
                                        fileName: file.name,
                                        path: rel,
                                        size: file.size,
                                        file: file
                                    });
                                }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (filesArray_1_1 && !filesArray_1_1.done && (_a = filesArray_1.return)) _a.call(filesArray_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    // Validation: Ensure we have at least one model number folder with valid PDF files
                    if (filesByFolder.size === 0 || !parentFolderName_1) {
                        setErrorText(translate('fileUpload.emptyFolderError'));
                        onValidationError(true, FileErrorType.TypeError);
                        setCurrentErrorType(FileErrorType.TypeError);
                        return [2 /*return*/];
                    }
                    folderStructure = {
                        parentFolderName: parentFolderName_1 || 'Unknown',
                        modelNumbers: Array.from(filesByFolder.entries()).map(function (_a) {
                            var _b = __read(_a, 2), folderName = _b[0], files = _b[1];
                            return ({
                                modelNumber: folderName,
                                fullPath: folderPaths_1.get(folderName) || "".concat(parentFolderName_1, "/").concat(folderName),
                                files: files.map(function (f) { return ({
                                    fileName: f.fileName,
                                    path: f.path,
                                    size: f.size,
                                    sizeInMB: (f.size / 1024 / 1024).toFixed(2),
                                    file: f.file
                                }); })
                            });
                        }),
                        totalFiles: Array.from(filesByFolder.values()).reduce(function (sum, files) { return sum + files.length; }, 0)
                    };
                    // Single console log with complete structure for backend dev
                    // Design dev: See dummy-folder-structure.ts for example data structure
                    // Call onFolderUpload callback with folder structure
                    if (onFolderUpload && filesByFolder.size > 0) {
                        folderNames = Array.from(filesByFolder.keys());
                        try {
                            onFolderUpload(folderNames, folderStructure);
                        }
                        catch (_d) {
                            onFolderUpload(folderNames[0], folderStructure);
                        }
                    }
                    return [3 /*break*/, 10];
                case 1:
                    duplicateFiles = filesArray.filter(function (file) { return isFileAlreadyUploaded(file); });
                    if (duplicateFiles.length > 0) {
                        duplicateFileError(duplicateFiles[0].name);
                        return [2 /*return*/];
                    }
                    validFiles = [];
                    corruptedFileNames = [];
                    _loop_1 = function (file) {
                        var isValid, existingFile;
                        return __generator(this, function (_e) {
                            switch (_e.label) {
                                case 0:
                                    if (!allowedFileTypes.includes('PDF')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, validatePDF(file)];
                                case 1:
                                    isValid = _e.sent();
                                    if (!isValid) {
                                        corruptedFileNames.push(file.name);
                                        return [2 /*return*/, "continue"];
                                    }
                                    _e.label = 2;
                                case 2:
                                    existingFile = fileDetails.find(function (uploadedFile) { var _a; return ((_a = uploadedFile.uploadedFile) === null || _a === void 0 ? void 0 : _a.name) === file.name; });
                                    if (existingFile) {
                                        validFiles.push({
                                            id: nanoid(),
                                            uploadedFile: file,
                                            uploaded: true,
                                            fileName: file.name,
                                            isDownloadable: false,
                                            isLinked: existingFile.isLinked,
                                            linkedDocumentId: existingFile.linkedDocumentId,
                                            isPublic: existingFile.isPublic
                                        });
                                    }
                                    else {
                                        validFiles.push({
                                            id: nanoid(),
                                            uploadedFile: file,
                                            uploaded: true,
                                            fileName: file.name,
                                            isDownloadable: false,
                                            isLinked: false,
                                            linkedDocumentId: null,
                                            isPublic: false
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 7, 8, 9]);
                    filesArray_2 = __values(filesArray), filesArray_2_1 = filesArray_2.next();
                    _c.label = 3;
                case 3:
                    if (!!filesArray_2_1.done) return [3 /*break*/, 6];
                    file = filesArray_2_1.value;
                    return [5 /*yield**/, _loop_1(file)];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    filesArray_2_1 = filesArray_2.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (filesArray_2_1 && !filesArray_2_1.done && (_b = filesArray_2.return)) _b.call(filesArray_2);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    // If there are corrupted files, show error
                    if (corruptedFileNames.length > 0) {
                        errorMessage = corruptedFileNames
                            .map(function (fileName) { return tWithField('fileUpload.corruptedFileError', fileName); })
                            .join('\n');
                        setErrorText(errorMessage);
                        onValidationError(true, FileErrorType.CorruptedError);
                        setCurrentErrorType(FileErrorType.CorruptedError);
                        setCanUpload(true);
                    }
                    else {
                        // No errors in new upload - clear any existing errors
                        setErrorText('');
                        onValidationError(false, FileErrorType.NoError);
                        setCurrentErrorType(FileErrorType.NoError);
                    }
                    // Upload valid files even if some were corrupted
                    if (validFiles.length > 0) {
                        updatedFiles = __spreadArray(__spreadArray([], __read(uploadedFiles), false), __read(validFiles), false);
                        setUploadedFiles(updatedFiles);
                        onChange(updatedFiles);
                    }
                    _c.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveFiles = function (fileNames) {
        var fileNamesToRemove = new Set(fileNames);
        var updatedFiles = uploadedFiles.filter(function (fileData) { var _a; return !((_a = fileData.uploadedFile) === null || _a === void 0 ? void 0 : _a.name) || !fileNamesToRemove.has(fileData.uploadedFile.name); });
        var filesToDelink = initialFiles
            .filter(function (f) { return fileNames.includes(f.fileName); })
            .map(function (d) { return d.id; });
        if (filesToDelink)
            handleDelink(filesToDelink);
        setUploadedFiles(updatedFiles);
        setCanUpload(true);
        setCurrentErrorType(FileErrorType.NoError);
        onChange(updatedFiles);
    };
    var handleDownloadable = function (fileName, isDownloadable, uploaded) {
        var updatedFiles = [];
        if (uploaded) {
            updatedFiles = uploadedFiles.map(function (fileData) { var _a; return ((_a = fileData.uploadedFile) === null || _a === void 0 ? void 0 : _a.name) === fileName ? __assign(__assign({}, fileData), { isDownloadable: isDownloadable }) : fileData; });
        }
        else {
            updatedFiles = uploadedFiles.map(function (fileData) {
                return fileData.fileName === fileName ? __assign(__assign({}, fileData), { isDownloadable: isDownloadable }) : fileData;
            });
        }
        setUploadedFiles(updatedFiles);
        setCanUpload(true);
        onChange(updatedFiles);
    };
    var calculateFileSize = function (fileSize) {
        var sizeInKB = fileSize / 1024;
        var sizeInMB = sizeInKB / 1024;
        if (sizeInMB >= 1) {
            return "".concat(sizeInMB.toFixed(2), " MB");
        }
        else {
            return "".concat(sizeInKB.toFixed(2), " KB");
        }
    };
    return (_jsxs(Grid, { size: { xs: 12 }, children: [_jsxs(Box, { sx: {
                    flexDirection: { xs: 'column', md: 'row' }
                }, children: [_jsx(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', borderRadius: '12px', padding: theme.spacing(2.5), sx: {
                            backgroundColor: enableFolderUpload || isFileUpload
                                ? alpha(theme.palette.grey[500], 0.08)
                                : '#919EAB14',
                            height: '100%',
                            width: '100%',
                            border: enableFolderUpload || isFileUpload
                                ? "1px dashed ".concat(alpha(theme.palette.grey[500], 0.2))
                                : '1px dashed rgba(145, 158, 171, 0.20)'
                        }, children: enableFolderUpload ? (_jsxs(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0.5, alignItems: 'center', sx: {
                                cursor: existingModelCount >= 10 ? 'not-allowed' : 'pointer',
                                opacity: existingModelCount >= 10 ? 0.5 : 1
                            }, onClick: function () {
                                if (existingModelCount >= 10) {
                                    return;
                                }
                                var input = document.createElement('input');
                                input.type = 'file';
                                input.webkitdirectory = true;
                                input.multiple = true;
                                input.accept = allowedFileTypes.join(',');
                                input.onchange = function (e) {
                                    var _a;
                                    var target = e.target;
                                    if (target.files && target.files.length > 0) {
                                        handleFileChange(Array.from(target.files));
                                    }
                                    else if (((_a = target.files) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                                        // Empty folder selected (onchange fired but no files)
                                        setErrorText(translate('fileUpload.emptyFolderError'));
                                        onValidationError(true, FileErrorType.TypeError);
                                    }
                                };
                                input.click();
                            }, children: [enableFolderUpload ? (_jsx(FolderIconDuoTone, {})) : isFileUpload ? (_jsx(FileIconDuoTone, {})) : (_jsx(CloudUploadIcon, {})), _jsx(Typography, { variant: 'body2', color: theme.palette.text.disabled, style: { wordBreak: 'break-all' }, children: uploadLabel })] })) : (_jsx(FileUploader, { multiple: true, handleChange: handleFileChange, types: allowedFileTypes, disabled: !canUpload, required: true, onTypeError: fileTypeError, onSizeError: fileSizeError, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0.5, alignItems: 'center', sx: { cursor: 'pointer' }, children: [isFolderUpload ? (_jsx(FolderIconDuoTone, {})) : isFileUpload ? (_jsx(FileIconDuoTone, {})) : (_jsx(CloudUploadIcon, {})), _jsx(Typography, { variant: 'body2', color: theme.palette.text.disabled, style: { wordBreak: 'break-all' }, children: uploadLabel })] }) })) }), uploadedFiles.length > 0 && (_jsxs(Box, { mt: 1, display: 'flex', padding: 1, flexDirection: 'column', borderRadius: '12px', gap: '8px', bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1, minWidth: 0, children: [_jsx(Typography, { variant: 'body2', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', children: "".concat(uploadedFiles.length, " ").concat(translate('common.files'), " ") }), _jsxs(Box, { gap: 0.5, display: 'flex', children: [uploadedFiles.filter(function (x) { return x.uploaded === true; }).length > 1 &&
                                                (isXs ? (_jsx(IconButton, { color: 'error', size: 'Xs', onClick: function () {
                                                        return handleRemoveFiles(uploadedFiles
                                                            .filter(function (x) { return x.uploaded === true && x.uploadedFile !== null; })
                                                            .map(function (x) { var _a; return (_a = x.uploadedFile) === null || _a === void 0 ? void 0 : _a.name; }));
                                                    }, children: _jsx(X, {}) })) : (_jsx(Button, { size: 'small', variant: 'soft', color: 'error', onClick: function () {
                                                        return handleRemoveFiles(uploadedFiles
                                                            .filter(function (x) { return x.uploaded === true && x.uploadedFile !== null; })
                                                            .map(function (x) { var _a; return (_a = x.uploadedFile) === null || _a === void 0 ? void 0 : _a.name; }));
                                                    }, startIcon: _jsx(X, {}), children: translate('assets.removeAll') }))), uploadedFiles.filter(function (x) { return x.isLinked === true; }).length > 1 &&
                                                (isXs ? (_jsx(IconButton, { size: 'Xs', color: 'inherit', onClick: function () {
                                                        return handleDelink(uploadedFiles
                                                            .map(function (file) { return file.id; })
                                                            .filter(function (id) { return id !== null; }));
                                                    }, children: _jsx(Unlink05Icon, {}) })) : (_jsx(Button, { size: 'small', variant: 'soft', color: 'inherit', onClick: function () {
                                                        return handleDelink(uploadedFiles
                                                            .map(function (file) { return file.id; })
                                                            .filter(function (id) { return id !== null; }));
                                                    }, startIcon: _jsx(Unlink05Icon, {}), children: translate('assets.delinkAll') })))] })] }), _jsx(Box, { display: 'flex', flexDirection: 'column', maxHeight: '180px', overflow: 'auto', gap: 1, pr: 0.5, children: uploadedFiles.map(function (fileData, index) {
                                    var _a, _b;
                                    return (_jsxs(Box, { sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.common.white,
                                            padding: '4px 8px',
                                            gap: '4px'
                                        }, children: [_jsxs(Box, { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsxs(Box, { display: 'flex', alignItems: 'center', children: [_jsx(Switch, { size: 'small', checked: fileData.isDownloadable, onClick: function () {
                                                                    var _a, _b;
                                                                    return handleDownloadable((_b = (_a = fileData.uploadedFile) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : fileData.fileName, !fileData.isDownloadable, fileData.uploaded);
                                                                } }), _jsx(Typography, { variant: 'caption', color: '#161C24', children: translate('fileUpload.downloadable') })] }), _jsxs(Box, { display: 'flex', gap: 1, children: [fileData.uploadedFile !== null && (_jsx(IconButton, { size: 'Xs', onClick: function () { var _a; return handleRemoveFiles([(_a = fileData.uploadedFile) === null || _a === void 0 ? void 0 : _a.name]); }, sx: { color: 'red' }, children: _jsx(X, {}) })), fileData.isLinked && fileData.linkedDocumentId && (_jsx(IconButton, { size: 'Xs', onClick: function () { return handleDelink([fileData.id]); }, children: _jsx(Unlink05Icon, {}) }))] })] }), fileData.isLinked ? (_jsx(Typography, { variant: 'caption', fontWeight: 600, color: theme.palette.text.primary, style: {
                                                    wordBreak: 'break-all',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden'
                                                }, children: fileData.fileName })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: 'caption', fontWeight: 600, color: theme.palette.text.primary, style: {
                                                            wordBreak: 'break-all',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis',
                                                            overflow: 'hidden'
                                                        }, children: (_a = fileData.uploadedFile) === null || _a === void 0 ? void 0 : _a.name }), _jsxs(Typography, { variant: 'caption', fontWeight: 400, color: theme.palette.text.tertiary, whiteSpace: 'nowrap', style: { wordBreak: 'break-all' }, children: ["(", calculateFileSize((_b = fileData.uploadedFile) === null || _b === void 0 ? void 0 : _b.size), ")"] })] })), fileData.uploadedFile !== null && (_jsx(Box, { children: _jsx(Chip, { color: 'primary', label: translate('assets.originalUploadedFile'), size: 'small', variant: 'soft', sx: {
                                                        '& .MuiChip-label': {
                                                            fontWeight: 600
                                                        }
                                                    } }) }))] }, fileData.id));
                                }) })] }))] }), infoText && (_jsx(FormHelperText, { sx: { display: 'flex', justifyContent: 'center', textAlign: 'center' }, children: infoText })), errorText && (_jsx(FormHelperText, { error: true, children: errorText.split('\n').map(function (line, index) { return (_jsxs(Fragment, { children: [line, index < errorText.split('\n').length - 1 && _jsx("br", {})] }, line)); }) }))] }));
};
export default MultipleLinkedFileUpload;
